import { render, staticRenderFns } from "./ConfirmDevice.vue?vue&type=template&id=23ee3db6&scoped=true"
import script from "./ConfirmDevice.vue?vue&type=script&lang=js"
export * from "./ConfirmDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ee3db6",
  null
  
)

export default component.exports